export const WetlandType = {
  POND: 'POND',
  SWAMP: 'SWAMP',
  LAKE: 'LAKE',
  SPRING: 'SPRING',
  STREAM: 'STREAM',
  RIVER: 'RIVER',
  CANAL: 'CANAL',
  WET_MEADOW: 'WET_MEADOW',
  PEAT_BOG: 'PEAT_BOG',
  OXBOW_LAKE: 'OXBOW_LAKE',
};

export const WaterClarity = {
  CLEAR: 'CLEAR',
  SLIGHTLY_CLOUDY: 'SLIGHTLY_CLOUDY',
  CLOUDY: 'CLOUDY',
};

export const WaterColor = {
  TRANSPARENT: 'TRANSPARENT',
  GREEN: 'GREEN',
  BROWN: 'BROWN',
  GRAY: 'GRAY',
  REDDISH: 'REDDISH',
  BLUE: 'BLUE',
  YELLOW: 'YELLOW',
  OTHER: 'OTHER',
};

export const CanSeeBottom = {
  YES: 'YES',
  BARELY: 'BARELY',
  NO: 'NO',
};

export const SurfaceAlgae = {
  NO: 'NO',
  YES_FEW: 'YES_FEW',
  YES_MANY: 'YES_MANY',
};

export const WaterPlants = {
  YES: 'YES',
  NO: 'NO',
};

export const SurroundingPlants = {
  YES: 'YES',
  NO: 'NO',
};

export const SeenAnimals = {
  FISH: 'FISH',
  AMPHIBIANS: 'AMPHIBIANS',
  BIRDS: 'BIRDS',
  INSECTS: 'INSECTS',
  REPTILES: 'REPTILES',
  OTHER: 'OTHER',
};

export const ObservedThreat = {
  CHEMICAL_POLLUTION: 'CHEMICAL_POLLUTION',
  BIOLOGICAL_POLLUTION: 'BIOLOGICAL_POLLUTION',
  INDUSTRIAL_WASTE: 'INDUSTRIAL_WASTE',
  MUNICIPAL_WASTE: 'MUNICIPAL_WASTE',
  INCREASED_SEDIMENTATION: 'INCREASED_SEDIMENTATION',
  DAM_OR_BARRIER_CONSTRUCTION: 'DAM_OR_BARRIER_CONSTRUCTION',
  WATER_FLOW_DIVERSION: 'WATER_FLOW_DIVERSION',
  EXCESSIVE_WATER_EXTRACTION: 'EXCESSIVE_WATER_EXTRACTION',
  DECREASED_OXYGEN_LEVEL: 'DECREASED_OXYGEN_LEVEL',
  INVASIVE_SPECIES: 'INVASIVE_SPECIES',
  DROUGHT: 'DROUGHT',
  FLOOD: 'FLOOD',
  EROSION: 'EROSION',
  OVERFISHING: 'OVERFISHING',
  PRESENCE_OF_LEAD_SHOT: 'PRESENCE_OF_LEAD_SHOT',
  PRESENCE_OF_RADIOACTIVE_MATERIALS: 'PRESENCE_OF_RADIOACTIVE_MATERIALS',
  OTHER: 'OTHER',
};

